import { DexDispatcherFormEnumType, DexFormsResponse } from '@mark43/cad-api';
import { DEX_FORMS_KEYS_ORDER } from '../data-exchange/forms/constants';

export function getDexDefaultForm(
    dexFormsResponse: DexFormsResponse
): DexDispatcherFormEnumType | undefined {
    for (const dataProp of DEX_FORMS_KEYS_ORDER) {
        if (dexFormsResponse[dataProp]) {
            return dexFormsResponse[dataProp]?.dexFormView?.dexDispatcherForm;
        }
    }

    return undefined;
}
